import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, unref as _unref, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = { class: "filter-container" }
const _hoisted_3 = { style: {"width":"200px"} }
const _hoisted_4 = { style: {"margin-left":"20px","width":"200px"} }
const _hoisted_5 = { style: {"width":"200px"} }
const _hoisted_6 = { class: "preview-list el-upload-list el-upload-list--picture-card" }

import { defineComponent, getCurrentInstance, reactive, watch, ref } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useStore } from '@/store/index'
import { UserMutationTypes } from '@/store/modules/user/mutation-types'
import { getCheckListApi, saveCheckApi, getTypeListApi } from '@/apis/qualification'
import SelectBrand from '@/components/SelectBrand.vue'
import Pagination  from '@/components/Pagination.vue'
import { CheckType } from '@/enums/qualification'
import { getFileSuffix } from '../../utils/index'

interface typeI {
    id: string,
    name: string
}
interface rowI {
    brand_id: string,
    mold_id: string,
    brand_name: string,
    status: string,
    type: string,
    check_status: string,
    check_at: string,
    create_at: string,
    end_time: string,
}

export default /*@__PURE__*/_defineComponent({
  __name: 'Check',
  setup(__props) {

const { proxy } = getCurrentInstance() as any
const router = useRouter()
const store = useStore()

const filters = reactive({
    brand_id: '', // 品牌ID
    mold_id: '', // 资质类型
    status: 0, // 审核状态
    start_date: '', // 提交开始日期
    end_date: '', // 提交结束日期
    check_start_date: '', // 审核开始日期
    check_end_date: '', // 审核结束日期
    page: 1, // 页码
    page_size: 10, // 每页条数
})

const businessDialogVisible = ref(false)
const businessFormData = reactive({
    id_name: '', // 法人姓名
    id_number: '', // 法人身份证号
    id_photo: '', // 法人身份证
    province: '', // 省
    city: '', // 市
    registered_address: '', // 户籍地址
    business_license: '', // 营业执照
    end_time: '', // 过期时间
    long_time: '', // 是否长期
})

// 资质类型
const typeList = ref<typeI[]>([])
const getTypeList = async() => {
    const { code, data, msg } = await getTypeListApi() as any
    if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
    typeList.value = data
}
getTypeList()

// 表单每行数据类型
const total = ref(0)
const tableData = ref<rowI[]>([])
const previewList = ref<any[]>([])
const getList = async () => {
    const { code, data, msg } = await getCheckListApi(filters) as any
    if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
    total.value = data.total
    tableData.value = data.data
    previewList.value = data.data.img_urls
}
getList()


// 审核弹框
const currRow = reactive<rowI>({
    brand_id: '',
    mold_id: '',
    brand_name: '',
    status: '',
    type: '',
    check_status: '',
    check_at: '',
    create_at: '',
    end_time: '',
})
const checkDialog = ref(false)

// 点击查看
const onCheck = (row) => {
    Object.assign(currRow, row)
    Object.assign(businessFormData, row)
    if (row.mold_id == '5') {
        businessDialogVisible.value = true
    } else {
        previewList.value = row.img_urls
        checkDialog.value = true
    }
}

// 驳回弹框
const rejectDialog = ref(false)
const reject_msg = ref('')
const onRejectDialogClose = () => {
    reject_msg.value = ''
    rejectDialog.value = false
}

// 保存审核结果
const saveCheck = async (check_type) => {
    const { brand_id, mold_id } = currRow
    let postData:any = {}
    postData.brand_id = brand_id
    postData.mold_id = mold_id
    postData.check_type = check_type
    if (check_type == 2) {
        if (!reject_msg.value) {
            return proxy.$message({ type: 'error', message: '请输入驳回原因' })
        }
        postData.msg = reject_msg.value
    }
    const { code, data, msg } = await saveCheckApi(postData) as any
    if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
                
    // 菜单提醒数字减一
    store.commit(UserMutationTypes.MINUS_MENU_WARNING_ITEM, 'certification')

    proxy.$message({ type: 'success', message: '保存成功' })
    businessDialogVisible.value = false
    rejectDialog.value = false
    checkDialog.value = false
    onRejectDialogClose()
    getList()
}

const onBrandChange = (val) => {
    filters.brand_id = val
}
const onSearch = () => {
    filters.page = 1
    getList()
}

const onPageChange = (val) => {
    filters.page = val
    getList()
}
const onSizeChange = (val) => {
    filters.page_size = val
    getList()
}

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(SelectBrand, { onBrandChange: onBrandChange }),
      _createVNode(_component_el_select, {
        class: "filter-item",
        modelValue: filters.mold_id,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filters.mold_id) = $event)),
        filterable: "",
        placeholder: "资质类型",
        clearable: ""
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(typeList.value, (item) => {
            return (_openBlock(), _createBlock(_component_el_option, {
              key: item.id,
              label: item.name,
              value: item.id
            }, null, 8, ["label", "value"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_select, {
        class: "filter-item",
        modelValue: filters.status,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.status) = $event)),
        filterable: "",
        placeholder: "审核状态",
        clearable: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_option, {
            label: "待审核",
            value: 0
          }),
          _createVNode(_component_el_option, {
            label: "审核通过",
            value: 1
          }),
          _createVNode(_component_el_option, {
            label: "驳回",
            value: 2
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_date_picker, {
        class: "filter-item",
        modelValue: filters.check_start_date,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filters.check_start_date) = $event)),
        placeholder: "审核开始时间",
        "value-format": "YYYY-MM-DD",
        clearable: ""
      }, null, 8, ["modelValue"]),
      _cache[30] || (_cache[30] = _createElementVNode("span", { class: "filter-divider" }, "-", -1)),
      _createVNode(_component_el_date_picker, {
        class: "filter-item",
        modelValue: filters.check_end_date,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filters.check_end_date) = $event)),
        placeholder: "审核结束时间",
        "value-format": "YYYY-MM-DD",
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_date_picker, {
        class: "filter-item",
        modelValue: filters.start_date,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((filters.start_date) = $event)),
        placeholder: "提交开始时间",
        "value-format": "YYYY-MM-DD",
        clearable: ""
      }, null, 8, ["modelValue"]),
      _cache[31] || (_cache[31] = _createElementVNode("span", { class: "filter-divider" }, "-", -1)),
      _createVNode(_component_el_date_picker, {
        class: "filter-item",
        modelValue: filters.end_date,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((filters.end_date) = $event)),
        placeholder: "提交结束时间",
        "value-format": "YYYY-MM-DD",
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_button, {
        class: "filter-btn",
        type: "primary",
        onClick: _cache[6] || (_cache[6] = ($event: any) => (onSearch()))
      }, {
        default: _withCtx(() => _cache[29] || (_cache[29] = [
          _createTextVNode("搜索")
        ])),
        _: 1
      })
    ]),
    _createVNode(_component_el_table, {
      data: tableData.value,
      stripe: "",
      border: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "brand_name",
          label: "品牌"
        }),
        _createVNode(_component_el_table_column, { label: "品牌状态" }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.row.brand_status ? '上架' : '下架'), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "img_name",
          label: "资质类型"
        }),
        _createVNode(_component_el_table_column, { label: "审核状态" }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(_unref(CheckType)[scope.row.status]), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "check_date",
          label: "审核时间"
        }),
        _createVNode(_component_el_table_column, {
          prop: "add_time",
          label: "提交时间"
        }),
        _createVNode(_component_el_table_column, {
          label: "操作",
          fixed: "right"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_button, {
              size: "small",
              type: "primary",
              onClick: ($event: any) => (onCheck(scope.row))
            }, {
              default: _withCtx(() => _cache[32] || (_cache[32] = [
                _createTextVNode("查看")
              ])),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(Pagination, {
      currentPage: filters.page,
      total: total.value,
      pageSize:  filters.page_size,
      onPageChange: onPageChange,
      onSizeChange: onSizeChange
    }, null, 8, ["currentPage", "total", "pageSize"]),
    _createVNode(_component_el_dialog, {
      title: "图片上传",
      modelValue: businessDialogVisible.value,
      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((businessDialogVisible).value = $event))
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_el_button, {
            onClick: _cache[17] || (_cache[17] = ($event: any) => {businessDialogVisible.value = false;})
          }, {
            default: _withCtx(() => _cache[33] || (_cache[33] = [
              _createTextVNode("取消")
            ])),
            _: 1
          }),
          (currRow.status == '0')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_component_el_button, {
                  type: "warning",
                  onClick: _cache[18] || (_cache[18] = ($event: any) => (rejectDialog.value = true))
                }, {
                  default: _withCtx(() => _cache[34] || (_cache[34] = [
                    _createTextVNode("驳回")
                  ])),
                  _: 1
                }),
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: _cache[19] || (_cache[19] = ($event: any) => (saveCheck(1)))
                }, {
                  default: _withCtx(() => _cache[35] || (_cache[35] = [
                    _createTextVNode("审核通过")
                  ])),
                  _: 1
                })
              ], 64))
            : _createCommentVNode("", true)
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: businessFormData,
          "label-width": "140",
          disabled: true
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "法人姓名：" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: businessFormData.id_name,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((businessFormData.id_name) = $event)),
                  modelModifiers: { trim: true }
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "法人身份证号：" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: businessFormData.id_number,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((businessFormData.id_number) = $event)),
                  modelModifiers: { trim: true }
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "法人身份证：" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_el_image, {
                    src: businessFormData.id_photo?.split(',')[0],
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (previewList.value = [businessFormData.id_photo?.split(',')[0]])),
                    "preview-src-list": previewList.value,
                    fit: "scale-down",
                    "hide-on-click-modal": "",
                    "append-to-body": "",
                    "z-index": 3000
                  }, null, 8, ["src", "preview-src-list"])
                ]),
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_el_image, {
                    src: businessFormData.id_photo?.split(',')[1],
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (previewList.value = [businessFormData.id_photo?.split(',')[1]])),
                    "preview-src-list": previewList.value,
                    fit: "scale-down",
                    "hide-on-click-modal": "",
                    "append-to-body": "",
                    "z-index": 3000
                  }, null, 8, ["src", "preview-src-list"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "选择省市：" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: businessFormData.province,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((businessFormData.province) = $event))
                }, null, 8, ["modelValue"]),
                _createVNode(_component_el_input, {
                  modelValue: businessFormData.city,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((businessFormData.city) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "户籍地址：" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: businessFormData.registered_address,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((businessFormData.registered_address) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "营业执照：",
              prop: "business_license"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  (_unref(getFileSuffix)(businessFormData.business_license)==='pdf')
                    ? (_openBlock(), _createBlock(_component_el_link, {
                        key: 0,
                        href: businessFormData.business_license,
                        target: "_blank"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_image, {
                            src: "//image-oss.dangaoss.cn/common/common_20230704142716_83.png",
                            fit: "scale-down",
                            "z-index": 3000
                          })
                        ]),
                        _: 1
                      }, 8, ["href"]))
                    : (_openBlock(), _createBlock(_component_el_image, {
                        key: 1,
                        src: businessFormData.business_license,
                        onClick: _cache[14] || (_cache[14] = ($event: any) => (previewList.value = [businessFormData.business_license])),
                        "preview-src-list": previewList.value,
                        fit: "scale-down",
                        "hide-on-click-modal": "",
                        "append-to-body": "",
                        "z-index": 3000
                      }, null, 8, ["src", "preview-src-list"]))
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "过期时间：" }, {
              default: _withCtx(() => [
                (businessFormData.long_time == '1')
                  ? (_openBlock(), _createBlock(_component_el_checkbox, {
                      key: 0,
                      style: {"margin-left":"20px"},
                      modelValue: businessFormData.long_time,
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((businessFormData.long_time) = $event)),
                      label: "长期",
                      size: "large",
                      "true-value": 1,
                      "false-value": 0
                    }, null, 8, ["modelValue"]))
                  : (_openBlock(), _createBlock(_component_el_date_picker, {
                      key: 1,
                      modelValue: businessFormData.end_time,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((businessFormData.end_time) = $event)),
                      placeholder: "请选择过期时间",
                      "value-format": "YYYY-MM-DD"
                    }, null, 8, ["modelValue"]))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "审核",
      modelValue: checkDialog.value,
      "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((checkDialog).value = $event))
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_el_button, {
            onClick: _cache[22] || (_cache[22] = ($event: any) => {checkDialog.value = false;})
          }, {
            default: _withCtx(() => _cache[37] || (_cache[37] = [
              _createTextVNode("取消")
            ])),
            _: 1
          }),
          (currRow.status == '0')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_component_el_button, {
                  type: "warning",
                  onClick: _cache[23] || (_cache[23] = ($event: any) => (rejectDialog.value = true))
                }, {
                  default: _withCtx(() => _cache[38] || (_cache[38] = [
                    _createTextVNode("驳回")
                  ])),
                  _: 1
                }),
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: _cache[24] || (_cache[24] = ($event: any) => (saveCheck(1)))
                }, {
                  default: _withCtx(() => _cache[39] || (_cache[39] = [
                    _createTextVNode("审核通过")
                  ])),
                  _: 1
                })
              ], 64))
            : _createCommentVNode("", true)
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("ul", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(previewList.value, (item, index) => {
            return (_openBlock(), _createElementBlock("div", null, [
              (_openBlock(), _createElementBlock("li", {
                class: "preview-item el-upload-list__item",
                key: index
              }, [
                (_unref(getFileSuffix)(item)==='pdf')
                  ? (_openBlock(), _createBlock(_component_el_link, {
                      key: 0,
                      href: item,
                      target: "_blank"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_image, {
                          src: "//image-oss.dangaoss.cn/common/common_20230704142716_83.png",
                          fit: "scale-down",
                          "z-index": 3000
                        })
                      ]),
                      _: 2
                    }, 1032, ["href"]))
                  : (_openBlock(), _createBlock(_component_el_image, {
                      key: 1,
                      src: item,
                      "preview-src-list": previewList.value,
                      "initial-index": index,
                      fit: "scale-down",
                      "hide-on-click-modal": "",
                      "append-to-body": "",
                      "z-index": 3000
                    }, null, 8, ["src", "preview-src-list", "initial-index"]))
              ])),
              _createVNode(_component_el_link, {
                class: "file-name",
                title: ((item.split('/'))[item.split('/').length-1]).split('?')[0],
                type: "primary",
                underline: false,
                href: item,
                target: "_blank"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(((item.split('/'))[item.split('/').length-1]).split('?')[0]), 1)
                ]),
                _: 2
              }, 1032, ["title", "href"])
            ]))
          }), 256))
        ]),
        _createVNode(_component_el_row, {
          class: "mt10",
          style: {"display":"flex","align-items":"center"}
        }, {
          default: _withCtx(() => [
            _cache[36] || (_cache[36] = _createElementVNode("span", null, "过期日期：", -1)),
            _createVNode(_component_el_input, {
              type: "text",
              modelValue: currRow.end_time,
              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((currRow.end_time) = $event)),
              disabled: "",
              style: {"display":"inline","width":"30%"}
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "审核",
      modelValue: rejectDialog.value,
      "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((rejectDialog).value = $event)),
      "before-close": onRejectDialogClose
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          type: "info",
          plain: "",
          onClick: onRejectDialogClose
        }, {
          default: _withCtx(() => _cache[40] || (_cache[40] = [
            _createTextVNode("取 消")
          ])),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "warning",
          onClick: _cache[27] || (_cache[27] = ($event: any) => (saveCheck(2)))
        }, {
          default: _withCtx(() => _cache[41] || (_cache[41] = [
            _createTextVNode("驳 回")
          ])),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_el_input, {
            type: "textarea",
            modelValue: reject_msg.value,
            "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((reject_msg).value = $event)),
            modelModifiers: { trim: true },
            maxlength: "100",
            rows: 4,
            "show-word-limit": "",
            placeholder: "请输入驳回原因"
          }, null, 8, ["modelValue"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})